import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const { loginWithOIDC } = useAuth();
  const [params] = useSearchParams();
  const returnTo = params.get('returnTo') || '/';
  const error = params.get('error');

  useEffect(() => {
    if (error === 'auth_failed') {
      toast.error('Sign-in failed. Please try again.');
    }
  }, [error]);

  return (
    <div
      className="flex items-center justify-center px-4"
      style={{ minHeight: '100vh', background: 'var(--scpa-bg)' }}
    >
      <div className="card w-full max-w-sm">
        <h1 className="text-xl font-semibold text-fg mb-2">
          ctTicketing
        </h1>
        <p className="text-sm text-muted mb-6">
          Sign in with your ctOneAuth account.
        </p>
        <button
          type="button"
          onClick={() => loginWithOIDC(returnTo)}
          className="btn btn-primary w-full"
        >
          Sign in with ctOneAuth
        </button>
        <button
          type="button"
          onClick={() => loginWithOIDC(returnTo, 'login')}
          className="mt-3 w-full text-center text-sm text-primary hover:underline"
        >
          Use a different account
        </button>
        <p className="mt-4 text-center text-sm text-muted">
          No account?{' '}
          <Link to="/register" className="text-primary hover:underline">
            Create one
          </Link>
        </p>
        <p className="mt-2 text-center text-sm text-muted">
          Customer?{' '}
          <Link to="/portal/register" className="text-primary hover:underline">
            Sign up for the Customer Portal
          </Link>
        </p>
      </div>
    </div>
  );
}
